import useSWR from "swr";
import { PATH_INVENTARIOS } from "../constants/routes";
import {
  messageLoading,
  messageSuccessLoading,
  validaMessagesErrors,
} from "../helpers";
import { axiosConToken } from "../helpers/axios";
import { types } from "../types/typesPeriodoContable";

const key = "key_periodocontable";

export const periodoContableStartLoad = () => {
  return async (dispatch) => {
    dispatch(ShowLoading());
    try {
      const resp = await axiosConToken.get(PATH_INVENTARIOS.periodocontable);
      dispatch(periodoContableLoaded(resp.data));
    } catch (error) {
      console.log(error);
      validaMessagesErrors(error, key);
    } finally {
      dispatch(ShowLoading(false));
    }
  };
};
export const periodoContableStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(
        PATH_INVENTARIOS.periodocontable,
        data
      );
      const { msg, periodocontable } = resp.data;
      dispatch(periodoContableInserted(periodocontable));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const periodoContableStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_INVENTARIOS.periodocontable}${data.id}/`,
        data
      );
      const { msg, periodocontable } = resp.data;
      dispatch(periodoContableUpdated(periodocontable));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const periodoContableStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_INVENTARIOS.periodocontable}${data.id}/`
      );
      const { msg } = resp.data;
      dispatch(periodoContableDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const periodoContableLoaded = (productos) => ({
  type: types.periodocontableLoaded,
  payload: productos,
});
const periodoContableInserted = (periodocontable) => ({
  type: types.periodocontableAdded,
  payload: periodocontable,
});
const periodoContableUpdated = (periodocontable) => ({
  type: types.periodocontableUpdated,
  payload: periodocontable,
});
const periodoContableDeleted = (periodocontable) => ({
  type: types.periodocontableDeleted,
  payload: periodocontable,
});
export const periodoContableSetActive = (periodocontable) => ({
  type: types.periodocontableSetActive,
  payload: periodocontable,
});
export const periodoContableClearActive = () => ({
  type: types.periodocontableClearActive,
});
const ShowLoading = (loading = true) => ({
  type: types.periodocontableLoading,
  payload: loading,
});

// ASYNC FUNCTIONS
export const usePeriodosContables = () => {
  const { data, isLoading, error } = useSWR(
    `${PATH_INVENTARIOS.periodocontable}`
  );
  if (error) {
    validaMessagesErrors(error);
    return {
      data: [],
      isLoading: false,
      error,
    };
  }
  return {
    data: data || [],
    isLoading,
    error: null,
  };
};
export const useEstadosperiodocontable = () => {
  const { data, isLoading, error } = useSWR(
    `${PATH_INVENTARIOS.periodocontable}get_estadosperiodocontable/`
  );
  if (error) {
    validaMessagesErrors(error);
    return {
      data: [],
      isLoading: false,
      error,
    };
  }
  return {
    data: data || [],
    isLoading,
    error: null,
  };
};
